export enum ClienteEstado {
  Borrador,
  Baja,
  Verificado,
  Alta,
}

export const ClienteEstadoLabels: { [key in ClienteEstado]: string } = {
  [ClienteEstado.Borrador]: 'Borrador',
  [ClienteEstado.Baja]: 'Baja',
  [ClienteEstado.Verificado]: 'Verificado',
  [ClienteEstado.Alta]: 'Alta',
};

export const colorMapping: { [key in ClienteEstado]: string } = {
  [ClienteEstado.Borrador]: '#70BDFF',
  [ClienteEstado.Baja]: '#FF0000',
  [ClienteEstado.Verificado]: '#22c55e',
  [ClienteEstado.Alta]: '#007bff',
};

export const getClienteEstado = () => {
  return Object.values(ClienteEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ClienteEstadoLabels[id as ClienteEstado],
    }));
};
